import { useState } from 'react';
import { Box, Tooltip, Typography, Menu, MenuItem, Popover } from '@mui/material';
import { AccountCircle, ChatBubble, Close, Menu as MenuIcon, Logout } from '@mui/icons-material';
import { useTheme, useMediaQuery } from '@mui/material';
import {
  NavBarContainer,
  Logo,
  IconButtonStyled,
  HamburgerButtonStyled
} from '../styles/Navbar';
import connitLogo from '../assets/images/logo/connit-learn.png';

const Navbar = ({ setCurrentPage }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleMenuItemClick = (button, event) => {
    if (button === 'close') {
      setCurrentPage('landing');
    } else if (button === 'profile') {
      setProfileAnchorEl(event.currentTarget);
    }
    handleMenuClose();
  };

  const menuItems = [
    { icon: <ChatBubble />, label: "New Chat", button: "newChat" },
    { icon: <AccountCircle />, label: "Profile", button: "profile" },
    { icon: <Close />, label: "Close", button: "close" }
  ];

  const email = "r.sham@vegascg.com"; // Email address

  return (
    <NavBarContainer>
      <Logo src={connitLogo} alt="Connit Labs Logo" />
      <Typography variant='h6' sx={{ fontSize: { xs: '1rem', sm: '1.5rem' } }}>
        Genie AI - Chatbot
      </Typography>
      {isMobile ? (
        <>
          <HamburgerButtonStyled onClick={handleMenuOpen}>
            <MenuIcon />
          </HamburgerButtonStyled>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            keepMounted
          >
            {menuItems.map(({ icon, label, button }, index) => (
              <MenuItem key={index} onClick={(event) => handleMenuItemClick(button, event)}>
                {icon}
                <Typography variant="body1" sx={{ marginLeft: "0.2em" }}>
                  {label}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : (
        <Box>
          {menuItems.map(({ icon, label, button }, index) => (
            <Tooltip title={label} key={index} arrow>
              <IconButtonStyled button={button} onClick={(event) => handleMenuItemClick(button, event)}>
                {icon}
              </IconButtonStyled>
            </Tooltip>
          ))}
        </Box>
      )}

      {/* Profile Popup */}
      <Popover
        open={Boolean(profileAnchorEl)}
        anchorEl={profileAnchorEl}
        onClose={() => setProfileAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box sx={{ padding: 2 }}>
          {/* Profile Name */}
          <Box display="flex" alignItems="center" sx={{ padding: '8px 0' }}>
            <AccountCircle sx={{ color: theme.palette.primary.main }} />
            <Typography variant="body1" sx={{ marginLeft: 1, color: theme.palette.primary.main }}>
              Sham Roshan
            </Typography>
          </Box>
          {/* Email Address */}
          <Typography variant="body2"
            sx={{ marginTop: 1, marginBottom: 1, color: theme.palette.text.secondary, borderBottom: '1px solid #ccc', padding: '4px 0' }}>
            {email}
          </Typography>
          {/* Logout Option */}
          <Box display="flex" alignItems="center" onClick={() => { 
            setProfileAnchorEl(null); 
            setCurrentPage('login'); // Ensure this is set to 'login'
          }} sx={{ cursor: 'pointer', padding: '8px 0' }}>
            <Logout sx={{ color: theme.palette.error.main }} />
            <Typography variant="body1" sx={{ marginLeft: 1, color: theme.palette.error.main }}>
              Logout
            </Typography>
          </Box>
        </Box>
      </Popover>
    </NavBarContainer>
  );
};

export default Navbar;
